import { ActionTypes, ProgramTypes } from '../ChannelArchitecture.d';

export const schedulesReducer = (state, { actionType, payload, saveChange }) => {
  switch (actionType) {
    case ActionTypes.CREATE:
      return {
        ...state,
        previous:
          state.previous.length == 0
            ? [{ item: [...state.programmes] }]
            : [...state.previous, { item: [...state.programmes] }],
        programmes: [...state.programmes, ...payload.item],
      };

    case ActionTypes.UPDATE: {
      const itemsById = new Map(payload.items.map((item) => [item.id, item]));
      const updated = state.programmes.map((item) => {
        return itemsById.has(item.id) ? { ...itemsById.get(item.id) } : item;
      });
      return {
        ...state,
        previous: [...state.previous, { item: [...state.programmes] }],
        programmes: updated,
      };
    }

    case ActionTypes.DELETE: {
      const { idsToDelete, itemsToUpdate } = payload;
      const itemsById = new Map(itemsToUpdate.map((item) => [item.id, item]));

      const programmes = state.programmes
        .filter((item) => !idsToDelete.includes(item.id))
        .map((item) => (itemsById.has(item.id) ? { ...itemsById.get(item.id) } : item));

      return {
        ...state,
        previous: [...state.previous, { item: [...state.programmes] }],
        programmes,
      };
    }

    case ActionTypes.UPDATEALL:
      return {
        previous: !state.previous ? [] : saveChange ? [...state.previous, { item: [...state.programmes], action: 'UPDATEALL' }] : [...state.previous],
        programmes: payload.programmes,
      };
    case ActionTypes.UNDO:
      return {
        ...state,
        programmes: payload?.previous ? state.programmes : state.previous[state.previous.length - 1].item,
        previous: payload?.previous ? payload.previous : state.previous.slice(0, -1),
      };

    default:
      return state;
  }
};

/* eslint-disable */
export const cAModalReducer = (state, payload) => {
  const action = payload.action;
  if (action === 'changeValue') {
    const newValues = payload.newValues;
    return {
      ...state,
      ...newValues,
    };
  } else {
    const type = payload.type;
    const disablePlacement =
      payload.disablePlacement ??
      [ProgramTypes.REPEAT, ProgramTypes.MOVIES, ProgramTypes.PLACEHOLDER].includes(type);
    switch (type) {
      case 'Movies':
        return {
          ...state,
          type: type,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
          sequential: false,
          series: null,
          seasons: null,
          titleGroup: null,
        };

      case 'Placeholder':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          sequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
          series: null,
          seasons: null,
          titleGroup: null,
        };

      case 'Series':
        return {
          ...state,
          type: type,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: false,
          disableSeries: false,
          disablePlacement,
          disableTitleGroup: true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: state.series ? true : false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
          titleGroup: null,
        };

      case 'TitleGroup':
      case 'Title Group':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: true,
          disableSeries: true,
          disablePlacement,
          disableTitleGroup: false,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: state.titleGroup ? true : false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
          series: null,
          seasons: null,
        };

      case 'Repeat':
        return {
          ...state,
          type: type,
          disableGenre: true,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeason: state.seasons?.id ? false : true,
          disableSeries: state.series?.id ? false : true,
          disablePlacement,
          disableTitleGroup: state.titleGroup || state.titleGroupID ? false : true,
          disableLayout: false,
          disableSequential: false,
          disableStartTime: false,
          disableLinkReference: state.disableLinkToggle,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
        };

      default:
        return {
          ...state,
          disableGenre: false,
          disableMaxCount: false,
          disableAvailableDuration: false,
          disableSeries: false,
          disableTitleGroup: false,
          disableLayout: false,
          disableSequential: false,
          disableLinkReference: state.disableLinkToggle,
          disablePlacement,
          disableType: false,
          disableReccurrence: false,
          disableDayOfWeek: false,
          disableEndTime: false,
          disableLinkToggle: false,
          layout: payload.layout || state.layout,
        };
    }
  }
};
